import Box from "@mui/material/Box";
import FlexSideDrawer from "designSystem/components/flex/FlexSideDrawer";
import page from "csi/page";
import { useStore } from "csi/state/hooks";
import { action } from "mobx";
import { observer } from "mobx-react-lite";
import React from "react";
import LayoutContent from "./LayoutContent";
import LayoutNavigator from "./LayoutNavigator";

// NOT CURRENTLY USED - prototype of tabs on left rather than top

const LayoutView = observer((props) => {
	const { browserStore, layoutStore } = useStore();
	const { fullScreenLeftDrawerClosed, fullScreenLeftDrawerClosedInitially } = browserStore;

	const onToggleOpen = action((open: boolean) => {
		// when user interacts with left drawer, reset setting to force it closed
		layoutStore.leftPaneOpen = open;
		browserStore.fullScreenLeftDrawerClosed = false;
		browserStore.fullScreenLeftDrawerClosedInitially = false;
	});

	return (
		<FlexSideDrawer
			drawerNode={<LayoutNavigator />}
			onToggleOpen={onToggleOpen}
			onTransition={page.resize}
			open={layoutStore.leftPaneOpen && !fullScreenLeftDrawerClosed && !fullScreenLeftDrawerClosedInitially}
		>
			<Box
				height={1}
				overflow="auto"
				pt={2}
				px={4}
			>
				<LayoutContent />
			</Box>
		</FlexSideDrawer>
	);
});

export default LayoutView;
